export const tableHeader = [
  {
    id: 'name',
    type: 'text',
    value: 'Nome',
  },
  {
    id: "gapAnalysisName",
    type: '',
    value: 'Gap Analysis',
  },
  {
    id: 'created_at',
    type: 'datebr',
    value: 'Data',
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]